/**
 * Vibra AI Chat — chiama un endpoint backend (proxy OpenAI), non include mai la API key.
 */
(function () {
  'use strict';

  function qs(root, sel) {
    return root.querySelector(sel);
  }

  function escapeHtml(s) {
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  function formatAssistantText(text) {
    if (!text) return '';
    var escaped = escapeHtml(text);
    return escaped.replace(/\n/g, '<br>');
  }

  function init(container) {
    var endpoint = container.getAttribute('data-endpoint');
    if (!endpoint) return;

    var systemPrompt = container.getAttribute('data-system-prompt') || '';
    var messagesEl = qs(container, '[data-vibra-ai-messages]');
    var form = qs(container, '[data-vibra-ai-form]');
    var input = qs(container, '[data-vibra-ai-input]');
    var sendBtn = qs(container, '[data-vibra-ai-send]');
    var errorEl = qs(container, '[data-vibra-ai-error]');
    var consent = qs(container, '[data-vibra-ai-consent]');

    if (!messagesEl || !form || !input) return;

    var history = [];

    function setError(msg) {
      if (!errorEl) return;
      if (msg) {
        errorEl.hidden = false;
        errorEl.textContent = msg;
      } else {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }
    }

    function appendBubble(role, content) {
      var wrap = document.createElement('div');
      wrap.className = 'vibra-ai-chat__bubble vibra-ai-chat__bubble--' + role;
      wrap.setAttribute('role', role === 'assistant' ? 'status' : 'log');
      var inner =
        role === 'user'
          ? escapeHtml(content).replace(/\n/g, '<br>')
          : formatAssistantText(content);
      wrap.innerHTML = '<div class="vibra-ai-chat__bubble-inner">' + inner + '</div>';
      messagesEl.appendChild(wrap);
      messagesEl.scrollTop = messagesEl.scrollHeight;
    }

    function buildPayload(userText) {
      var msgs = [];
      if (systemPrompt.trim()) {
        msgs.push({ role: 'system', content: systemPrompt.trim() });
      }
      for (var i = 0; i < history.length; i++) {
        msgs.push(history[i]);
      }
      msgs.push({ role: 'user', content: userText });
      return { messages: msgs };
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      setError('');

      var text = (input.value || '').trim();
      if (!text) return;

      if (consent && consent.required && !consent.checked) {
        setError(consent.getAttribute('data-error') || 'È necessario accettare per continuare.');
        return;
      }

      appendBubble('user', text);
      history.push({ role: 'user', content: text });
      input.value = '';
      input.focus();

      var loading = document.createElement('div');
      loading.className = 'vibra-ai-chat__bubble vibra-ai-chat__bubble--assistant vibra-ai-chat__typing';
      loading.innerHTML =
        '<div class="vibra-ai-chat__bubble-inner"><span class="vibra-ai-chat__dot"></span><span class="vibra-ai-chat__dot"></span><span class="vibra-ai-chat__dot"></span></div>';
      messagesEl.appendChild(loading);
      messagesEl.scrollTop = messagesEl.scrollHeight;

      if (sendBtn) sendBtn.disabled = true;

      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(buildPayload(text))
      })
        .then(function (r) {
          return r.text().then(function (text) {
            var body = {};
            try {
              body = text ? JSON.parse(text) : {};
            } catch (_e) {
              if (!r.ok) throw new Error('Errore ' + r.status);
              throw new Error('Risposta non valida dal server.');
            }
            if (!r.ok) {
              var err =
                (body && body.error) ||
                ('Errore ' + r.status);
              throw new Error(typeof err === 'string' ? err : JSON.stringify(err));
            }
            return body;
          });
        })
        .then(function (data) {
          loading.remove();
          var reply = (data && data.reply) || '';
          if (!reply && data && data.choices && data.choices[0]) {
            reply = (data.choices[0].message && data.choices[0].message.content) || '';
          }
          if (!reply) throw new Error('Risposta vuota dal servizio.');
          history.push({ role: 'assistant', content: reply });
          appendBubble('assistant', formatAssistantText(reply));
        })
        .catch(function (err) {
          loading.remove();
          history.pop();
          var prev = messagesEl.querySelector('.vibra-ai-chat__bubble--user:last-of-type');
          if (prev) prev.remove();
          setError(err.message || 'Impossibile contattare l’assistente. Riprova tra poco.');
        })
        .finally(function () {
          if (sendBtn) sendBtn.disabled = false;
        });
    });
  }

  document.querySelectorAll('[data-vibra-ai-chat]').forEach(init);
})();
